define(['tpaGalleries/galleries/tpaGallery', 'tpaGalleries/galleries/tpaGalleryCurrentItemMixin'], function (tpaGallery, tpaGalleryCurrentItemMixin) {
    'use strict';
    /**
     * @class components.thumbnails
     * @extends {core.tpaGallery}
     */
    return {
        displayName: 'ThumbnailsGallery',
        mixins: [tpaGallery, tpaGalleryCurrentItemMixin],
        statics: {
            behaviors: {
                nextSlide: {methodName: 'next'},
                prevSlide: {methodName: 'prev'}
            }
        },
        getGalleryType() {
            return 'Thumbnails';
        },
        getStyleProps() {
            return {
                'textColor': 'color1',
                'descriptionColor': 'color2',
                'textBackgroundColor': 'color3'
            };
        }
    };
});
